import React, { useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// components
import ModalDialog from '../ModalDialog';
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';

/** GenerateActivityRequest.name on the backend. */
const NAME_MAX_LENGTH = 200;

/**
 * Asked before "Genera attività" runs: an optional name for the activity, which
 * is what makes it easy to find in the general views (Dashboard, project) where
 * no cue or track is selected. Left empty, the activity keeps its generic label.
 *
 * The name is only accepted by generate-activity — the edit endpoint has no
 * `name` — so it has to be given here, before the activity exists.
 */
const ModalGenerateActivity = ({ visible, onHide, onSubmit }) => {
    const {
        control,
        handleSubmit,
        formState: { isValid },
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: { name: '' }
    });

    useEffect(() => {
        if (visible) reset({ name: '' });
    }, [visible, reset]);

    const submit = ({ name }) => {
        onSubmit(name.trim() || null);
        onHide();
    };

    return (
        <ModalDialog
            additionalClasses={['modalGenerateActivity']}
            header={__('Genera attività', 'soundbetween')}
            visible={visible}
            onSubmit={handleSubmit(submit)}
            onHide={onHide}
            width={420}>
            <form className="appForm formInModal" onSubmit={handleSubmit(submit)}>
                <fieldset>
                    <FormField
                        type="text"
                        name="name"
                        label={__('Nome attività (facoltativo)', 'soundbetween')}
                        placeholder={__('Es. Revisione intro del cue M03', 'soundbetween')}
                        control={control}
                        rules={{
                            maxLength: {
                                value: NAME_MAX_LENGTH,
                                message: __('Massimo 200 caratteri', 'soundbetween')
                            }
                        }}
                    />

                    <div className="appFormActions">
                        <ButtonFlat size="lg" onClick={(e) => { e.preventDefault(); onHide(); }}>
                            {__('Annulla', 'soundbetween')}
                        </ButtonFlat>
                        <ButtonFormSubmit disabled={!isValid}>
                            {__('Genera', 'soundbetween')}
                        </ButtonFormSubmit>
                    </div>
                </fieldset>
            </form>
        </ModalDialog>
    )
}

export default ModalGenerateActivity;
